import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { ClarityModule } from '@clr/angular';
import { CommonModule } from '@angular/common';
import { DateTimeInputComponent } from './date-time-input/date-time-input.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { DynamicFormInputComponent } from './dynamic-form-input/dynamic-form-input.component';
import { ErrorPageComponent } from './error-page/error-page.component'
import { ExcludeFilterDropDownPipe } from '../pipes/exclude-filter-drop-down.pipe';
import { HttpClientModule } from '@angular/common/http';
import { LoginLayoutComponent } from './layout/login-layout/login-layout.component';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NotificationComponent } from './notification/notification.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { TopbarComponent } from './layout/topbar/topbar.component';
import { WarningModalComponent } from './warning-modal/warning-modal.component';

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false},
  datePickerInput: {year: 'numeric', month: 'numeric', day: 'numeric', hour12: false },
  timePickerInput: {hour: 'numeric', minute: 'numeric', hour12: false},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'long'},
};

export let options: Partial<IConfig> | (() => Partial<IConfig>);
@NgModule({
  declarations: [
    AppLayoutComponent,
    NavbarComponent,
    SidebarComponent,
    LoginLayoutComponent,
    DynamicFormInputComponent,
    DynamicFormComponent,
    NotificationComponent,
    DateTimeInputComponent,
    ExcludeFilterDropDownPipe,
    TopbarComponent,
    WarningModalComponent,
    ErrorPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ClarityModule,
    NgSelectModule,
    NgxMaterialTimepickerModule,
    NgxMaskModule.forRoot(options),
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  providers: [
    {provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS},
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DynamicFormComponent,
    DynamicFormInputComponent,
    ClarityModule,
    NgSelectModule,
    NgxMaskModule,
    NgxMaterialTimepickerModule,
    WarningModalComponent
  ]
})


export class SharedModule { }
